import * as types from '../../actions/types';
import createReducer from '../../../utils/createReducer';

const initialShareState = { show: false, url: '' };

export const shareReducer = createReducer(initialShareState, {
  [types.SHOW_SHARE](state, action) {
    return { ...state, ...{ show: action.show, url: action.url } };
  }
});